import React from 'react'
import {
  BrowserRouter as Router, Route, Switch, Redirect,
} from 'react-router-dom'
import Loadable from 'react-loadable'
import { makeStyles } from '@material-ui/core/styles'
import Fade from '@material-ui/core/Fade'
import Header from 'components/Header'
import Footer from 'components/Footer'
import ScrollToTop from 'components/ScrollToTop'

import useRoutes from './utils/useRoutes'

const useStyles = makeStyles({
  root: {
    // maxWidth: 1280,
    // margin: '0 auto',
    // minHeight: '100vh',
    position: 'relative',
  },
  footer: {
    width: '100%',
    margin: '0 auto',
    position: 'relative',
  },
})

const Routes = () => {
  const classes = useStyles()
  const routes = useRoutes()

  return (
    <Router>
      <div className={classes.root}>
        <Route component={ScrollToTop} />
        <Header />
        <Switch>
          {
            routes.map((x) => (
              <Route
                key={x.path}
                path={x.path}
                exact={x.exact}
                render={(props) => {
                  if (!x.component) return <Redirect to="/" />

                  const matchesPath = props.location.pathname === x.path
                  const matchesNestedPath = props.location.pathname.includes(x.path)

                  return (
                    <Fade
                      in={matchesPath || matchesNestedPath}
                      timeout={500}
                      style={{ transitionDelay: '550ms' }}
                    >
                      <div>
                        <x.component {...props} />
                      </div>
                    </Fade>
                  )
                }}
              />
            ))
          }
          <Redirect to="/" />
        </Switch>
      </div>
      <Footer />
    </Router>
  )
}

export default Routes
